import React, { useState, useRef } from "react";

import PureDownloadDialog from "./PureDownloadDialog";

import Downloader from "./Downloader";

import Alert from "@material-ui/lab/Alert";

import { useAuth } from "lib/firebase-provider/Auth";

import { Snackbar } from "@material-ui/core";

import { useTranslation } from "react-i18next";

export default function DownloadDialog({
  open,
  onClose,
  minDate,
  maxDate,
  defaultCountry,
  defaultDate,
  defaultBaslineDate,
}) {
  const [pending, setPending] = useState(null);
  const [downloadError, setDownloadError] = useState(null);
  const downloader = useRef(null);

  const { t } = useTranslation();


  const handleCloseNotification = () => {
    setDownloadError(null);
  };

  const handleClose = () => {
    downloader.current = null;
    setPending(false);
    onClose();
  };

  const handleDownload = async ({
    level,
    country,
    county,
    state,
    startDate,
    endDate,
    baselineDate,
    hexagons
  }) => {
    setPending(true);

    downloader.current = new Downloader();

    downloader.current.download({
      level,
      country,
      state,
      county,
      start: startDate,
      end: endDate,
      baseline: baselineDate,
      hexagons,
      onCompleted: () => {
        setPending(false);
        onClose();
      },
      onError: (err) => {
        setPending(false);
        console.error(err);
        setDownloadError(err);
      },
    });
  };

  const { claims } = useAuth();
  const countries = claims?.["gd_download"];

  if (!countries) {
    return <div />;
  }

  return (
    <>
      <PureDownloadDialog
        open={open}
        onClose={handleClose}
        minDate={minDate}
        maxDate={maxDate}
        onDownload={handleDownload}
        pending={pending}
        defaultCountry={defaultCountry}
        defaultDate={defaultDate}
        defaultBaslineDate={defaultBaslineDate}
        countries={countries}
      />
      <Snackbar
        open={downloadError}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity="error"
          variant="filled"
        >
          {t("download.errorMessage")}
        </Alert>
      </Snackbar>
    </>
  );
}
